// ProtectedRoute.tsx
import React from "react";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const CustomerProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    // Vérifier si l'utilisateur est connecté
    const token = localStorage.getItem("token_customer_silverjarz");
    
    // Si pas de token, rediriger vers la page de login
    if (!token) {
        return <Navigate to="/login" replace />;
    }

    // Sinon, afficher le contenu protégé
    return <>{children}</>;
};

export default CustomerProtectedRoute;